module.exports = __webpack_public_path__ + "static/media/button_gochirareru.a2df5b34.png";